import { SocialIcon } from '@change/ds-core-ui/next';

import { ICON_VARIANTS } from './costants';
import { useSubComponentsFactory } from './factories/useSubComponentsFactory';
import { PostPreviewStyles } from './PostPreview.styles';
import type { PostPreviewProps } from './types';

export function PostPreview(props: PostPreviewProps) {
	const { variant, size, showPlatformIcon } = props;
	const mainStyles = PostPreviewStyles({ size });

	const { header, body, footer } = useSubComponentsFactory(props);
	const iconConfig = ICON_VARIANTS[variant];

	return (
		<section data-testid={`post-preview-${variant}`}>
			{/*
				The platform icon is usually shown at the large size, but it is not constrained to that size.
				However, to support other sizes, add the appropriate styles for each size.
			*/}
			{showPlatformIcon && (
				<div className="relative" aria-hidden>
					<div className="border-stroke-inverse-strong bg-background-inverse absolute -right-[11px] -top-[11px] flex h-12 w-12 items-center justify-center overflow-hidden rounded-full border">
						<SocialIcon
							data-testid="platform-icon"
							className="h-12 w-12"
							size="large"
							fullWidth={false}
							icon={<iconConfig.icon />}
							aria-hidden
							label=""
							variant={iconConfig.variant}
						/>
					</div>
				</div>
			)}
			<div className={mainStyles}>
				{header}
				{body}
				{footer}
			</div>
		</section>
	);
}
